import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import red from '@material-ui/core/colors/red';
import { TextField, PasswordField, Button, LoadingIndicator, NavigationLink, AppBar } from '../../components';
import { ThemeImages, ThemeColors } from '../../theme';
import grey from '@material-ui/core/colors/grey';
import { withStyles } from '@material-ui/core';
import LoginSignupWrapper from '../loginSignupWrapper';


class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      userName: '',
      password: '',
    };

    this.setUsername = this.setUsername.bind(this);
    this.setPassword = this.setPassword.bind(this);
    this.keyPress = this.keyPress.bind(this);
    this.login = this.login.bind(this);
  }

  setUsername(event) {
    this.setState({ userName: event.target.value });
  }

  setPassword(event) {
    this.setState({ password: event.target.value });
  }

  keyPress(event) {
    if (event.key === 'Enter') {
      this.login();
      event.preventDefault();
      return false;
    }
    return true;
  }

  login() {
    if (this.state.userName && this.state.userName !== '' && this.state.password && this.state.password !== '') {
      this.props.login({ userName: this.state.userName, password: this.state.password });
    }
  }

  renderLoginForm() {
    const { classes } = this.props;

    const errorContainerStyle = {
      backgroundColor: red[500],
      textAlign: 'center',
      color: 'white',
    };

    const ErrorMessage = (props) => {
      if (!props.errorMessage) {
        return null;
      }

      return (
        <div style={errorContainerStyle}>
          <span>{props.errorMessage}</span>
        </div>
      );
    };

    const LoginButton = (props) => {
      if (props.loading) {
        return <LoadingIndicator />;
      }

      return (<Button
        label="Einloggen"
        labelStyle={{ color: ThemeColors.darkTextOnPrimaryBackground ? 'black' : 'white' }}
        onClick={this.login}
        style={{ width: '100%' }}
        color="primary"
        variant="contained"
      />);
    };

    return (
      <form className={classes.formStyle} onKeyPress={this.keyPress} noValidate>
        <Typography className={classes.headerTypoStyle}>Login</Typography>
        <ErrorMessage {...this.props} />
        <div className={classes.formElementContainer}>
          {/* <Typography>Email</Typography> */}
          <TextField
            autoFocus
            required
            placeholder="E-Mail"
            value={this.state.userName}
            onChange={this.setUsername}
          />
        </div>
        <div className={classes.formElementContainer}>
          {/* <Typography>Passwort</Typography> */}
          <PasswordField
            required
            hintText="Passwort"
            value={this.state.password}
            onChange={this.setPassword}

          />
          <NavigationLink
            style={{
              fontWeight: 600,
              marginTop: 10,
              color: grey[400] }}
            to="forgotpassword"
          >Passwort vergessen?</NavigationLink>
        </div>
        <div className={classes.formElementContainer}>
          <LoginButton {...this.props} />
          <div
            style={{
              fontWeight: 600,
              marginTop: 10,
              width: '100%',
              textAlign: 'center',
            }}
          >
            <NavigationLink
              style={{
                color: grey[600] }}
              to="signup"
            >ZUR REGISTRIERUNG</NavigationLink>
          </div>

        </div>
      </form>
    );
  }

  render() {
    return (
      <LoginSignupWrapper
        title="Login"
        subtitle="bei der Smarter Lernen App"
        imageContainerStyle={{ background: 'linear-gradient(45deg, #942463, #68328a)' }}
      >
        {this.renderLoginForm()}
      </LoginSignupWrapper>
    );
  }
}

Login.propTypes = {
  login: PropTypes.func.isRequired,
};

const styles = () => ({
  formStyle: {
    padding: 5,
  },
  formElementContainer: {
    padding: 5,
    marginLeft: 10,
    marginRight: 10,
  },
  headerTypoStyle: {
    fontSize: 24,
    color: 'grey',
    fontWeight: 700,
    marginBottom: 20,
    marginLeft: 10,
    marginTop: 20,
  },
});

export default withStyles(styles)(Login);



// WEBPACK FOOTER //
// ./src/app/platform-startscreen/login/login.js